import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import { buildVuetifyThemes, getVuetifyThemeName } from '../theme/accentThemes';

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
  theme: {
    defaultTheme: getVuetifyThemeName('dark', 'standard'),
    themes: buildVuetifyThemes(),
  },
  defaults: {
    VCard: { rounded: 'xl' },
    VBtn: { rounded: 'xl' },
    VTextField: { variant: 'outlined', rounded: 'lg' },
    VTextarea: { variant: 'outlined', rounded: 'lg' },
    VSelect: { variant: 'outlined', rounded: 'lg' },
    VChip: { rounded: 'xl' },
  },
});
